import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import QuotationItem from "../../entity/emergency/QuotationItem";

const SERVICE = "service-emergency";
const ENTITY = "quotation_items";

export default function () {
    const {findAllBy, create, update, remove} = useApi();
    const state = useSelector;
    const newInstance = data => new QuotationItem(data);

    return {
        findAllByQuotationId(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.filter(pi => pi?.getQuotationId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findAllBy(SERVICE, ENTITY, "quotation_id", id, newInstance, "application_v7");
                }
            }
        },
        async create(payload) {
            return create(SERVICE, ENTITY, payload, newInstance, "application_v7");
        },
        async update(id, property, payload) {
            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        },
        async remove(id) {
            return remove(SERVICE, ENTITY, id, "application_v7");
        }
    }
}